
  export const Bills_Data =  [
     {
      id: 1,
      Id: "01",
      bill_received_via: 'Email',
      vendor: 'John Doe',
      created_by: 'Doe',
      created_on: '19 Oct, 1999',
      bill_status: "Pending",
    },
    {
      id: 2,
      Id: "01",
      bill_received_via: 'Manual',
      vendor: 'John Doe',
      created_by: 'Doe',
      created_on: '19 Oct, 1999',
      bill_status: "Approved", 
    },
    {
      id: 3,
      Id: "01",
      bill_received_via: 'File Upload',
      vendor: 'John Doe',
      created_by: 'Doe',
      created_on: '19 Oct, 1999',
      bill_status: 'Rejected'
    },
    {
        id: 4,
        Id: "01",
        bill_received_via: 'File Upload',
        vendor: 'John Doe',
        created_by: 'Doe',
        created_on: '19 Oct, 1999',
        bill_status: 'Partial'
      },
  ];